<template>

    <div class="l-d_navbar" id="dashboard-navbar">
        <h1 class="l-d_navbar__logo">
            <router-link to="/" class="l-d_navbar__logo-img"
                         title="Elektroniczna Dokumentacja Fizjoterapeutyczna"></router-link>
        </h1>
        <nav class="l-d_navbar__user">
            <span class="l-d_navbar__user-name">{{ userName }}</span>
            <v-btn type="green" size="small" class="back-to-portal-btn" @click="redirectToPortal">Wróć do portalu</v-btn>
            <v-btn type="icon" icon="logout" :to="{ name: 'Logout' }" title="Wyloguj"></v-btn>
        </nav>
    </div>

</template>


<script>

import VBtn from 'Components/VBtn'

export default {

    name: 'TheDashboardNavbar',

    computed: {
        userName() {
            return this.$auth.user().first_name + ' ' + this.$auth.user().last_name
        }
    },

    components: {
        VBtn
    },

    methods: {
        redirectToPortal() {
            window.location.href = window.portal_url;
        }
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.l-d_navbar {
    display: flex;
    position: relative;
    z-index: 9;
    justify-content: space-between;
    width: 100%;
    height: 70px;
    background-color: $c-white;
    border-bottom: 1px solid $c-border;
    padding: 0 20px;

    &__logo {
        display: flex;
        align-items: center;
        height: 100%;

        &-img {
            display: block;
            width: 100px;
            height: 42px;
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
            background-image: url('#{$img}/logo.svg');
        }
    }
    &__user {
        display: flex;
        align-items: center;
        height: 100%;
        margin: 0;
        padding: 0;

        &-name {
            font-weight: bold;
            color: $c-third;
            margin-right: 1rem;
        }

        .back-to-portal-btn {
            margin-right: 15px;
        }
    }
    @include bp($screen-md) {
        height: 50px;
        padding: 0 20px;

        &__user-name {
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &__logo {
            width: 50px;
        }
    }
}

</style>
